export { default } from './PageComposableHeaderContent'
